// What makes a survey a feedback survey.
//
// Its own module so callers that only need to recognise one — the Surveys page's
// "Customer feedback" tab — can do it without pulling in zustand, the block
// definitions and the survey-payload helpers the builder needs.

import { SurveyCategoryEnum } from "../../../../utils/enums";

/**
 * True when a survey record from the API is a customer-feedback survey.
 *
 * `surveyCategoryId` is the marker: `/survey/AddSurvey` stores it, and both
 * `Survey/GetPreviewData` and `getAllSurveysForProjectByStatus` return it. So a
 * feedback survey is recognised wherever it was created — another browser,
 * another user — and surveys authored before the field existed are, correctly,
 * not feedback surveys.
 */
export const isFeedbackSurvey = (survey) =>
   survey?.surveyCategoryId === SurveyCategoryEnum.CustomerFeedback;
